import { useLocation } from "react-router-dom";
import { GlobalChatWidget } from "./GlobalChatWidget";

/**
 * Pages where the global chat should be available
 */
const ENABLED_PAGES = [
  "/dashboard",
  "/practice",
  "/arena",
  "/tournament",
  "/competitive",
  "/tournament-create",
  "/my-roadmap",
  "/learning-hub",
  "/learning-paths",
];

/**
 * Check if global chat should be shown on the current page
 */
function shouldShowGlobalChat(pathname: string): boolean {
  // Check if current path starts with any enabled page
  return ENABLED_PAGES.some((page) => pathname.startsWith(page));
}

/**
 * Manages global chat visibility based on current route
 * Only shows on selected high-value pages
 */
export function GlobalChatManager() {
  const location = useLocation();
  const showChat = shouldShowGlobalChat(location.pathname);

  // Don't render anything if chat shouldn't be shown on this page
  if (!showChat) {
    return null;
  }

  return <GlobalChatWidget />;
}
